<template>
  <main-template>
    <v-container>
      <v-row>
        <v-col>
          <h1>
            <v-btn
              color="primary"
              x-small
              text
              @click="$router.push({ name: 'eventos-calendario-letivo' })"
            >
              <v-icon left>fa fa-angle-left</v-icon>
            </v-btn>
            Painel Administrativo - {{ editing ? "Editando" : "Criando" }} Eventos
          </h1>
        </v-col>
      </v-row>

      <v-card class="pa-4 mt-4">
        <v-form @submit.prevent="salvarEvento">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="evento.legenda"
                label="Legenda"
                maxlength="40"
                counter
                outlined
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-color-picker v-model="evento.cor" hide-inputs></v-color-picker>
            </v-col>
            <v-col cols="12">
              <v-checkbox
                v-model="evento.is_sabado_letivo"
                label="Este evento é um sábado letivo?"
                @change="
                  (val) => {
                    if (val) evento.is_feriado = false;
                  }
                "
              ></v-checkbox>
            </v-col>
            <v-col cols="12">
              <v-checkbox
                v-model="evento.is_feriado"
                label="Este evento é um Feriado?"
                @change="
                  (val) => {
                    if (val) evento.is_sabado_letivo = false;
                  }
                "
              ></v-checkbox>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-btn
                color="primary"
                :disabled="submittingForm"
                :loading="submittingForm"
                type="submit"
                block
                >Enviar Dados</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-container>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      evento: {
        legenda: "",
        cor: "#FF0000",
        ano_id: null,
        is_sabado_letivo: false,
        is_feriado: false,
      },
      eventos: [],
      submittingForm: false,
    };
  },

  computed: {
    ...mapGetters("Auth", ["user"]),
  },

  mounted() {
    this.loadEventos().then(() => {
      this.loadDataEvento();
    });
  },

  watch: {
    user: {
      immediate: true,
      handler(newUser) {
        if (newUser && newUser.ano) {
          this.evento.ano_id = newUser.ano.id;
        }
      },
    },
  },

  methods: {
    handleSabadoLetivoChange(value) {
      if (value) {
        this.evento.is_feriado = false;
      }
    },

    async loadEventos() {
      try {
        this.eventos = await this.$services.eventoCalendarioLetivoService.syncAll();
      } catch (error) {
        this.$handleError(error);
      }
    },

    loadDataEvento() {
      if (!this.editing) return;
      const { evento_id } = this.$route.params;
      const evento = this.eventos.find((e) => e.id === parseInt(evento_id, 10));
      if (evento) {
        this.evento = { ...evento };
      }
    },

    async salvarEvento() {
      this.submittingForm = true;

      if (!this.evento.legenda || this.evento.is_feriado === null) {
        this.$toast.danger("Por favor, informe a legenda e se o evento é um Feriado.");
        this.submittingForm = false;
        return;
      }

      const eventoParaSalvar = {
        ...this.evento,
        cor:
          typeof this.evento.cor === "object" ? this.evento.cor.hex : this.evento.cor || "#FF0000",
        legenda: this.evento.legenda, // Não alterar a legenda automaticamente
      };

      try {
        if (this.editing) {
          await this.$services.eventoCalendarioLetivoService.atualizarEvento(eventoParaSalvar);
          this.$toast.success("Evento editado com sucesso!");
        } else {
          await this.$services.eventoCalendarioLetivoService.criarEvento(eventoParaSalvar);
          this.$toast.success("Evento salvo com sucesso!");
        }
        this.$router.push({ name: "eventos-calendario-letivo" });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.submittingForm = false;
      }
    },
  },
};
</script>

<style scoped>
.v-color-picker {
  max-width: 300px;
}
</style>
